<template>
    <div class="guest-verification-status-page p-3">
        <div v-if="isSuccess" class="w-100 h-100">
            <card :header-class="['guest-verification-success-card-header']" :header-content-class="['w-100']">
                <template #header-icon>
                    <font-awesome-icon :icon="['fas', 'id-card']" size="lg" />
                </template>
                <template #header-content>Success!</template>
                <template #body>
                    <div>
                        <p>
                            Your ID has passed verification and has been attached to your upcoming reservation. We look
                            forward to your upcoming stay at {{ companyName }}.
                        </p>
                    </div>
                </template>
            </card>
        </div>
        <div class="w-100 h-100" v-else>
            <card :header-class="['guest-verification-reject-card-header']" :header-content-class="['w-100']">
                <template #header-icon>
                    <font-awesome-icon :icon="['fas', 'id-card']" size="lg" />
                </template>
                <template #header-content>Guest Verification Failed</template>
                <template #body>
                    <div class="d-flex flex-column errors-wrapper">
                        <span class="font-weight-bold"> An error occurred while attempting to verify your ID: </span>
                        <div class="d-flex flex-column" v-if="messages">
                            <span v-for="(msg, i) in messages" :key="msg">{{ i + 1 + '.' }} {{ msg }}</span>
                        </div>
                        <span
                            >Please contact the property manager to work out a way to verify your ID another way.</span
                        >
                    </div>
                </template>
            </card>
        </div>
    </div>
</template>

<script>
import card from '../../generic/card/card.vue';
export default {
    components: { card },
    data() {
        return {
            isSuccess: false,
            companyName: null,
        };
    },
    mounted() {
        this.isSuccess = Number(window.IS_SUCCESS);
        this.companyName = window.COMPANY_NAME;
    },
    computed: {
        messages() {
            return !this.isSuccess && window.WARNINGS && window.WARNINGS.split(';').filter((item) => !!item);
        },
    },
};
</script>

<style lang="scss" scoped>
:deep(.lx-card > div.guest-verification-success-card-header) {
    background-color: #28a745 !important;
    border-color: #28a745 !important;
}

:deep(.lx-card > div.guest-verification-reject-card-header) {
    background-color: #cf5329 !important;
    border-color: #cf5329 !important;
}
.errors-wrapper {
    gap: 20px;
}
</style>